import { ChangeDetectionStrategy, Component, ViewEncapsulation, input, computed, inject, output } from '@angular/core';
import { IOnboardingCompletionStep, IOnboardingCompletionUserStep } from '../../../fi-onboarding-completion';
import { FiOnboardingQuizCompletionStateType } from '../../../fi-onboarding-completion-enums';
import { FiOnboardingCompletionHelperService } from '../../../fi-onboarding-completion-helper.service';
import { isNullOrUndefined } from '@fi-app/shared/utils/is-null-or-undefined';
import { AppTextService } from '@fi-app/shared/app-text';
import { FiOnboardingStepCompletionDialogState } from '../../../fi-onboarding-step-completion-dialog/fi-onboarding-step-completion-dialog-state.service';

@Component({
    selector: 'fi-quiz-completed',
    templateUrl: './fi-quiz-completed.component.html',
    styleUrl: './fi-quiz-completed.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-quiz-completed' },
    standalone: false,
})
export class FiQuizCompletedComponent {
    public readonly step = input.required<IOnboardingCompletionStep>();
    public readonly userCompletionStep = input.required<IOnboardingCompletionUserStep>();
    public readonly retakeQuiz = output<void>();

    protected readonly isRetakeAllowed = computed(() => this.step().Quiz.AllowRetakes);

    protected readonly completionDialogState = inject(FiOnboardingStepCompletionDialogState);
    private readonly fiOnboardingCompletionHelperService = inject(FiOnboardingCompletionHelperService);
    private readonly appTextService = inject(AppTextService);

    protected readonly quizCompletionFailed = computed(
        () => this.userCompletionStep().QuizCompletion?.CompletionState === FiOnboardingQuizCompletionStateType.Failed,
    );

    protected quizCompletionsData = computed(() => {
        const step = this.step();
        const userCompletionStep = this.userCompletionStep();
        const quizCompletionFailed = this.quizCompletionFailed();
        const isRetakeAllowed = this.isRetakeAllowed();
        if (
            isNullOrUndefined(step) ||
            isNullOrUndefined(userCompletionStep) ||
            isNullOrUndefined(quizCompletionFailed) ||
            isNullOrUndefined(isRetakeAllowed)
        ) {
            return {};
        }
        if (quizCompletionFailed) {
            const correctAnswersCount = this.fiOnboardingCompletionHelperService.getCorrectQuizAnswersCount(
                step.Quiz,
                userCompletionStep.QuizCompletion.Answers,
            );
            return {
                iconClass: 'fal fa-face-sad-sweat failed',
                description: this.appTextService.get(
                    isRetakeAllowed
                        ? 'onboarding.quiz_completion_failed_retakes_allowed'
                        : 'onboarding.quiz_completion_failed',
                ),
                scoreLabel: this.appTextService.get('common.completion_result', {
                    '{0}': correctAnswersCount,
                    '{1}': step.Quiz.Questions.length,
                }),
            };
        }
        return {
            iconClass: 'fal fa-party-horn completed',
            description: this.appTextService.get('onboarding.quiz_completion_completed'),
        };
    });
}
